// extracted by mini-css-extract-plugin
export default {"container":"RHl5L","title":"dfxCj","widget":"ltSlm","skeleton-progress":"j15eR"};